import React, { Component } from 'react';
import FlexLib from '@flex/lib';
import { changeFocus } from '../../../helpers/changeFocusCard';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import classes from './Payment.module.scss';
import Container from '@material-ui/core/Container';
import { ErrorMessage } from '../../../components/Message/ErrorMessage';
import Grid from '@material-ui/core/Grid';
import { checkCreditOrDebit } from '../../../helpers/PostDataApi';
import autoFillMultipassFields from '../../../helpers/functions/autoFillCardFields';
import { UserDetailById } from '../../../actions/AdminUserAction';
import {
  getInvoiceNumber,
  InvoiceDetailByIdForPay,
  DownloadInvoice,
  getCsrfToken,
} from '../../../actions/PaymentAction';
import { countryDataList } from '../../../actions/CompanyAction';
import { Buttons } from '../../../components/Buttons';
import { Textfield } from '../../../components/Textfield';
import { SuccessMessage } from '../../../components/Message/SuccessMessage';
import { handleAddressSettingError } from '../../../helpers/functions/validateAddressfields';
import { initialAddressSettings, initialAddressState } from '../../../helpers/addressSettingsState';
import { CloseableAlerts } from '../../../components/Message/CloseableAlerts';
import config from '../../../constants/config';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import MaskedInput from 'react-maskedinput';
import classNames from 'classnames';
import { loadTsepManifestScript } from '../../../helpers/tsepUtils';
import Typography from '@material-ui/core/Typography';
import validator from '../../../helpers/checkValidations';
import LoadingOverlay from 'react-loading-overlay';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { setupPaymentGatewayProperties } from '../../../helpers/functions/paymentGateway.properties.js';
import { rules } from '../../../constants/IntakeFormConstants';
import AddressFieldsDropDown from '../../../components/AddressFieldsDropDown/AddressFieldsDropDown';
import { checkAddressEnabled } from '../../../helpers/functions/addressFieldsEnabled';
import { isDueDatePassed } from '../../../helpers/InvoiceHelper';
import { getPolicyPDF, getLocationTermsAndConditions } from '../../../actions/TermConditionsAction';
import './tsepFields.css';
import Topheader from '../../../components/Topheader/Topheader.js';
import { CustomerDetailsId } from '../../../actions/CustomerAction';
import { CardActions, Stack, Alert, Checkbox, FormControlLabel } from '@mui/material';
import PaymentConfirmation from '../../Payment/components/PaymentConfirmation.jsx';
import ACHForm from '../../../components/ACHForm/ACHForm.js';
import { DataGetApiV2, DataPostApiV2 } from '../../../helpers/PostDataApi';
import SelectAccount from '../../../components/SelectAccount/SelectAccount';
import commonStrings from '../../../constants/commonStrings';
import invoicesService from '../../../services/invoicesService.js';
import message from '../../../constants/message.js';
import { AlertSeverityTypes, FlexAlerts } from '../../../components/Message/Alerts/Alerts';
import FeeDisplay from '../../../components/FeeDisplay/FeeDisplay.jsx';
const { formatCurrency, formatCurrencyInput } = FlexLib.utils.feeService;

function TabedPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`action-tabpanel-${index}`}
      aria-labelledby={`action-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

TabedPanel.propTypes = {
  children: PropTypes.any,
  value: PropTypes.any,
  index: PropTypes.any,
};

const IsDeletedComponents = (props) => {
  return (
    <>
      <h3 className="errorMsg mb-3" style={{ textAlign: 'center' }}>
        {' '}
        This invoice ({props.invoiceId} ) has been deleted!{' '}
      </h3>
    </>
  );
};

IsDeletedComponents.propTypes = {
  invoiceId: PropTypes.any,
  t: PropTypes.any,
};

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FRONT_END: 'Customer Portal',
      baseAmount: '',
      paymentType: commonStrings.debit,
      calculationResult: {},
      binCodesResponse: null,
      selectedPaymentMethod: {},
      messages: [],
      activeTab: 0,
      cardPanelShow: true,
      americanExpress: false,
      isLoading: false,
      isOpen: false,
      payerName: '',
      creditOrDebit: null,
      invoice: '',
      notes: '',
      createdBy: '',
      companyId: '',
      isSubmit: false,
      addNewCard: false,
      isClose: false,
      cardWalletID: null,
      tsepFieldError: null,
      tsepFieldSuccess: false,
      tsepSuccessResponse: null,
      tsepAuth: false,
      dueDate: new Date(),
      invoiceDate: new Date(),
      misMatchError: [],
      CoustmerData: [],
      CardData: [],
      InvoicePendingData: [],
      successMessages: false,
      updateCard: false,
      tabValue: 0,
      indexValue: 0,
      salesTaxTotal: 0,
      paytraceCredentials: {},
      locationId: {},
      isStoredCard: false,
      isPayedByCustomer: true,
      customerData: null,
      userDetails: JSON.parse(localStorage.getItem('user')),
      customerId: { _id: '', firstName: '', lastName: '' },
      csrf: { 'csrf-token': '', 'csrf-secret': '' },
      virtualTerminalSettings: {},
      ...initialAddressSettings,
      ...initialAddressState,
      invoiceSettings: {},
      savedPaymentMethods: [],
      ach: {
        isOpen: false,
        isSaveChecked: false,
        accountName: '',
        accountNumber: '',
        routingNumber: '',
      },
      card: {
        isOpen: false,
        cardHolderName: '',
        cardNumber: '',
        cardExpiryDate: '__/____',
        cardCsc: '___',
        customerToken: false,
        customerTokenUpdate: false,
      },
      error: {
        amountError: false,
        payerNameError: false,
        zipError: false,
      },
      errorCard: {
        cardNumber: false,
        cardHolderName: false,
        cardExpiryDate: false,
        cardCsc: false,
      },
      invoiceLable: 'Invoice',
      isCustomFieldEnabled: false,
      jobId: '',
      isPaymentTermConditionEnabled: false,
      isInvoiceTermConditionEnabled: false,
      isReceiptTermConditionEnabled: false,
      isLateFeeApplicable: false,
      invoiceId: '',
      invoiceData: {},
    };
    this.paymentRef = React.createRef();
    this.cardRef = React.createRef();
    this.msgRef = React.createRef();
    this.expiryDateRef = React.createRef();
    this.cscCardRef = React.createRef();
    this.achFormValidationRef = React.createRef(null);
  }

  componentDidMount() {
    this.getCustomerDetails();
    this.getInvoiceData();
    this.getCsrfToken();
    this.getPaymentVault();
    document.addEventListener('tsepEventUpdate', this.handleTsepEventUpdated);
  }

  getCustomerDetails() {
    const userDetails = JSON.parse(localStorage.getItem('user'));
    this.props.CustomerDetailsId({ id: userDetails.customerId ?? process.env.CUSTOMER_TEMP_ID }).then((result) => {
      if (result.payload.customerData.data.statusCode === 200) {
        const { masked_card_number } = result.payload.customerData.data.response;
        this.setState({ customerData: result.payload.customerData.data.response });
        if (masked_card_number && masked_card_number !== '') {
          this.setState({
            isStoredCard: true,
            paymentType: result.payload.customerData.data.response?.creditOrDebit?.toLowerCase(),
          });
        }
      }
    });
  }

  getPaymentVault() {
    if (this.state.locationId?.ACHPaymentVault) {
      if (this.state.customerData?._id) {
        const query = {
          customerId: this.state.customerData._id,
        };

        DataGetApiV2(config.BASEURL + 'getPaymentVault', query)
          .then((response) => {
            if (response.data?.paymentMethods) {
              this.setState({ savedPaymentMethods: response.data.paymentMethods }); // don't set isSavedAccount because not account selected
            }
          })
          .catch((_error) => {
            const misMatchError = ['Could not get account data.'];
            this.setState({ misMatchError, selectedPaymentMethod: {} });
          });
      } else {
        this.setState({
          ach: { isOpen: false, isSaveChecked: false, accountName: '', accountNumber: '', routingNumber: '' },
          selectedPaymentMethod: {},
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if specific props or state values have changed before taking action
    if (
      this.state.locationId?.ACHPaymentVault &&
      (this.state.customerData !== prevState.customerData || this.state.locationId !== prevState.locationId)
    ) {
      this.setState({
        ach: { isOpen: false, isSaveChecked: false, accountName: '', accountNumber: '', routingNumber: '' },
        selectedPaymentMethod: {},
        savedPaymentMethods: [],
      });
      this.getPaymentVault();
    }
    // You can also perform actions unconditionally after each update
    // ...
  }

  setTsepCardPaymentType = () => {
    const cardNumberElement = document.getElementById('tsep-cardNum');
    if (cardNumberElement) {
      const cardNumberValue = cardNumberElement?.value.replace(/\s/g, '');
      this.checkCardPaymentType(cardNumberValue);
    }
  };

  handleTsepEventUpdated = (evnt) => {
    const tsepEventDetails = evnt.detail;
    if (tsepEventDetails.eventType === 'FieldValidationErrorEvent') {
      this.setState({ tsepFieldError: tsepEventDetails.event.message });
    } else if (tsepEventDetails.eventType === 'TokenEvent' && tsepEventDetails.event.status === 'PASS') {
      this.setState({
        tsepSuccessResponse: { ...tsepEventDetails.event },
        tsepFieldSuccess: true,
        tsepFieldError: null,
      });
      // Handle other cases if needed
    } else if (tsepEventDetails.eventType === 'TokenEvent' && tsepEventDetails.event.status === 'FAILURE') {
      this.setState({ tsepFieldError: tsepEventDetails.event.message });
    } else if (tsepEventDetails.eventType === 'FocusOutEvent' && tsepEventDetails.event.fieldName === 'tsep-cardNum') {
      this.setTsepCardPaymentType();
    } else if (
      tsepEventDetails.eventType === 'ErrorEvent' &&
      tsepEventDetails.event.status === 'FAIL' &&
      tsepEventDetails.event.responseCode === 'TSEPERR911'
    ) {
      this.setState({ tsepAuth: false });
    }
  };

  getCsrfToken() {
    this.props.getCsrfToken().then((res) => {
      this.setState({ csrf: { ...res.payload.paymentData.data } });
    });
  }

  getInvoiceData() {
    const {
      match: { params },
    } = this.props;
    this.setState({ isLoading: true });
    this.props.InvoiceDetailByIdForPay(params).then((res) => {
      if (res.payload.paymentData.data.success) {
        const data = res.payload.paymentData.data.response;
        if (data.achDetails == '' && this.state.activeTab == 0) {
          delete data.achDetails;
        }
        this.setState(
          {
            ...res.payload.paymentData.data.response,
            invoiceData: res.payload.paymentData.data.response,
            creditOrDebit: this.state.customerData?.creditOrDebit,
            isLoading: false,
            SurchargeFeeName: 'SVC Fee',
            locationId: data.locationId,
            companyId: data.companyId,
            card: {
              ...res.payload.paymentData.data.response.card,
              cardNumber: '',
            },
            baseAmount: formatCurrencyInput(res.payload.paymentData.data.response?.amount),
            payerName: `${data?.customerId?.firstName ?? ''} ${data?.customerId?.lastName ?? ''}`,
          },
          () => {
            if (!this.state.isZip) {
              delete this.state.zip;
              delete this.state.error.zipError;
            }
          }
        );
        if (res.payload.paymentData.data.response.locationId?.customFieldsEnabled) {
          const jobIdCustomField = res.payload.paymentData.data.response?.locationId?.customFields?.find(
            (field) => field?.enabled
          );
          if (jobIdCustomField) {
            this.setState({
              invoiceLable: jobIdCustomField.value,
              jobId: res.payload.paymentData.data.response.jobId,
              isCustomFieldEnabled: true,
            });
          }
        }

        if (
          data.locationId?.multipassCredentials &&
          data.locationId?.gateway &&
          data.locationId?.gateway === 'multipass'
        ) {
          this.handleTsepManifestUpdate(data.locationId);
        }
      }
      if (res.payload.paymentData.data.response?.invoiceSettings) {
        this.setState(
          {
            addressSettings: {
              ...this.state.addressSettings,
              shippingAddress: res.payload.paymentData.data.response?.invoiceSettings?.shippingAddress,
              billingAddress: res.payload.paymentData.data.response?.invoiceSettings?.billingAddress,
            },
            invoiceSettings: res.payload.paymentData.data.response?.invoiceSettings,
            dualFeeEnabled: res.payload.paymentData.data.response.DualFeeEnabled,
          },
          () => {
            const isLateFeeApplicable = isDueDatePassed(
              res.payload.paymentData.data.response,
              this.state.invoiceSettings?.CustomFeeOneDueDays
            );
            this.setState({ isLateFeeApplicable: isLateFeeApplicable });
          }
        );
      }
      if (res.payload.paymentData.data.statusCode === 401) {
        this.setState({ invalidMsg: res.payload.paymentData.data.message, isLoading: false });
      }
      if (this.state.locationId) {
        this.setPaymentGatewayProperties();
        this.fetchTermConditions();
      }
      if (this.state.isPaid) {
        this.props.history.push('/Customer/Payment/History');
      }
    });
  }

  fetchTermConditions() {
    this.props.getLocationTermsAndConditions(this.state.companyId._id, this.state.locationId?._id).then((res) => {
      if (res.payload) {
        this.setState(
          {
            isPTC: res.payload?.isPaymentTermConditionEnabled,
            isRTC: res.payload?.isReceiptTermConditionEnabled,
            isITC: res.payload?.isInvoiceTermConditionEnabled,
            isSPB: res.payload?.isSelfPaymentPageBannerEnabled,
            isPPB: res.payload?.isPaymentPageBannerEnabled,
            paymentTermCondition: res.payload?.paymentTermCondition ?? '',
            receiptTermCondition: res.payload?.receiptTermCondition ?? '',
            invoiceTermCondition: res.payload?.invoiceTermCondition ?? '',
            selfPaymentBanner: res.payload?.selfPaymentBanner ?? '',
            paymentPageBanner: res.payload?.paymentPageBanner ?? '',
            privacy_filename: res.payload?.privacy_policy,
            refund_filename: res.payload?.refund_policy,
          },
          () => {
            this.forceUpdate();
          }
        );
      }
    });
  }

  setPaymentGatewayProperties() {
    const paymentGateway = this.state.locationId?.gateway || 'paytrace';
    const { misMatchErrors, paytraceCredentials, multipassCredentials } = setupPaymentGatewayProperties(
      paymentGateway,
      this.state.locationId
    );
    if (misMatchErrors && misMatchErrors.length > 0) {
      this.setState({ misMatchErrors });
    } else {
      paymentGateway === 'paytrace'
        ? this.setState({ paytraceCredentials }, () => {
            const localUrl = config.BASEURL + 'getPemFile?fileName=';
            window.paytrace.setKeyAjax(localUrl + this.state.paytraceCredentials.paytraceKey);
          })
        : this.setState({ multipassCredentials });
    }
  }

  handleTsepManifestUpdate = (locationDetails) => {
    // Update the manifest with new TSEP details from server
    loadTsepManifestScript(locationDetails, 'paylink').then((auth) => {
      this.setState({ tsepAuth: auth });
    });
  };

  handleChange(event, _t) {
    let error = {};
    let misMatchError = [];
    let { id, value } = event.target;

    validator(id, value) ? (error[id + 'Error'] = true) : (error[id + 'Error'] = false);
    this.setState({ [id]: value, error, misMatchError, isSubmit: false });

    if (id === 'payerName' && value !== '' && typeof value === 'string') {
      this.setState({ payerName: value.charAt(0).toUpperCase() + value.slice(1) });
    }
  }

  fetchSettingData() {
    this.props.UserDetailById({ id: this.state.userDetails._id }).then((response) => {
      if (response.type === 'USER_SUCCESS' && response.payload.userData.status === 200) {
        this.setState({ ...response.payload.userData.data.settings, isLoading: false });
      }
    });
  }

  checkCardPaymentType = (firstNumber) => {
    checkCreditOrDebit(config.BIN_CHECKER_URL, config.BIN_API_KEY, firstNumber.substring(0, 6))
      .then((data) => {
        this.setState({
          binCodesResponse: data.data,
          cardType: data.data.card ? data.data.card : null,
          creditOrDebit: data.data.type ? data.data.type : null,
          paymentType: data.data.type ?? commonStrings.debit,
        });
      })
      .catch((err) => {
        console.log('err1', err);
      });
  };

  handleChangeCard(event, _t) {
    let error = {};
    let misMatchError = Array.from(this.state.misMatchError);
    let { id, value } = event.target;

    validator(id, value) ? (error[id + 'Error'] = true) : (error[id + 'Error'] = false);
    if (id === 'cardNumber' && value[0] === '3' && value.length === 16 && value[value.length - 1] === '_') {
      value = value.slice(0, -1);
    }

    if (id === 'cardExpiryDate') {
      const month = value.split('/')[0];
      if (month && month.length == 2 && (parseInt(month) <= 0 || parseInt(month) > 12)) {
        error[id + 'Error'] = true;
        if (!misMatchError.includes('invalid card expiry date')) misMatchError.push('invalid card expiry date');
      }
    }
    this.setState(
      {
        card: { ...this.state.card, [id]: value },
        errorCard: { ...this.state.errorCard, [id]: error[id + 'Error'] },
        error,
        misMatchError,
        isSubmit: false,
      },
      () => {
        let firstNumber = this.state.card.cardNumber !== '' ? this.state.card.cardNumber : null;
        if (firstNumber && id === 'cardNumber') {
          this.checkCardPaymentType(firstNumber);
        }
        if (firstNumber && firstNumber[0] === '3') {
          this.setState({ americanExpress: true });
        } else {
          this.setState({ americanExpress: false });
        }
      }
    );
    changeFocus(id, value, this.expiryDateRef.current, this.cscCardRef.current);
  }

  updateCardState(id, value, error) {
    let misMatchError = [];
    this.setState(
      {
        card: { ...this.state.card, [id]: value },
        errorCard: { ...this.state.errorCard, [id]: false },
        error,
        misMatchError,
        isSubmit: false,
      },
      () => {
        let firstNumber = this.state.card.cardNumber.substring(0, 14);
        if (firstNumber && id === 'cardNumber') {
          this.checkCardPaymentType(firstNumber);
        }
        if (firstNumber[0] === '3') {
          this.setState({ americanExpress: true });
        } else {
          this.setState({ americanExpress: false });
        }
      }
    );
  }
  handleChangeACH(event) {
    let error = {};
    let misMatchErrors = [];
    let { id, value } = event.target;
    validator(id, value) ? (error[id + 'Error'] = true) : (error[id + 'Error'] = false);
    this.setState(
      {
        ach: { ...this.state.ach, [id]: value },
        errorCard: { ...this.state.errorCard, [id]: false },
        error,
        misMatchError: misMatchErrors,
        isSubmit: false,
      },
      () => {}
    );
  }

  deletePreSubmitUnecessaryKeys() {
    if (this.state.customerId === null) {
      return false;
    }
    if (this.state.notes === '') {
      delete this.state.notes;
    }
    if (this.state.timestamp_PAID === '') {
      delete this.state.timestamp_PAID;
    }
    if (this.state.InvoiceSalesTaxFee === '' || this.state.InvoiceSalesTaxFee === 0) {
      delete this.state.InvoiceSalesTaxFee;
    }
    if (!this.state.isCustomFieldEnabled) {
      delete this.state.jobId;
    }
  }
  validatePreSubmitStateKeys(error) {
    let errorFlag = false;
    Object.keys(this.state).forEach((key) => {
      if (
        validator(key, this.state[key]) ||
        this.state[key] === '' ||
        (typeof this.state[key] === 'string' && this.state[key].trim() === '')
      ) {
        if (key === 'receiptTermCondition') {
          return false;
        }
        if (key === 'paymentTermCondition') {
          return false;
        }
        if (key === 'invoiceTermCondition') {
          return false;
        }
        error[key + 'Error'] = true;
        errorFlag = true;
      } else {
        error[key + 'Error'] = false;
      }
    });
    return errorFlag;
  }

  checkIsValid() {
    let isValid = true;

    if (this.state.ach.isOpen) {
      isValid = this.achFormValidationRef.current && this.achFormValidationRef.current.validate();
    }

    if (!this.state.calculationResult?.totalAmount) {
      this.setState({ misMatchError: ['Total has not been calculated.'] });
      isValid = false;
    }

    return isValid;
  }

  handleSubmit(e, _t) {
    e.preventDefault();
    let misMatchError = [];
    let logoError = [];
    let successMessages = false;
    let error = {};
    const paymentGateway = this.state?.locationId?.gateway || 'paytrace';
    this.setState({ isSubmit: true });
    this.deletePreSubmitUnecessaryKeys();

    if (!this.checkIsValid()) {
      return false;
    }

    const locationDetails = this.state?.locationId;
    const addressError = handleAddressSettingError(this.state);
    if (addressError.length > 0) {
      misMatchError = addressError;
      this.setState({ misMatchError: this.state.misMatchError.concat(misMatchError) });
      return false;
    }

    if (this.state.errorCard.cardExpiryDate) {
      if (!this.state.misMatchError.includes('invalid card expiry date')) {
        misMatchError.push('invalid card expiry date');
        this.setState({ misMatchError: this.state.misMatchError.concat(misMatchError) });
      }
      return false;
    }

    if (this.state.locationId?.ACHPaymentVault && this.state.ach.isSaveChecked) {
      if (this.state.customerData?._id) {
        const query = {
          customerId: this.state.customerData._id,
        };
        const payload = { ach: this.state.ach };

        DataPostApiV2(config.BASEURL + 'addPaymentMethodToVault', payload, query)
          .then((response) => {
            let newAccount = { ...response.data };
            this.setState({ savedPaymentMethods: [...this.state.savedPaymentMethods, newAccount] });
            this.getPaymentVault();
          })
          .catch((error) => {
            const misMatchError = [error?.response?.data?.message ?? 'Could not add account.'];
            this.setState({ misMatchError });
            return false;
          });
      }
    }

    const errorFlag = this.validatePreSubmitStateKeys(error);
    const cardValidation = paymentGateway === 'paytrace' ? this.checkCardValues(this.state) : false;
    if (!cardValidation && errorFlag && locationDetails?.customDefaultBuild) {
      this.setState({ misMatchError, logoError, error, successMessages });
      return false;
    }

    // Update Presubmit state to reflect pending status
    this.setState({ isLoading: true });

    // Define request params
    const invoiceId = this.state.invoiceId || '';
    const paymentDetails = { paymentType: '', paymentMethod: null };

    // Legacy Stored Card
    if (this.state.activeTab === 0 && this.state.isStoredCard) {
      paymentDetails.paymentType = this.state.customerData?.creditOrDebit?.toLowerCase() ?? commonStrings.debit;

      if (paymentGateway === commonStrings.paytrace) {
        paymentDetails.paymentMethod = {
          gatewayPaymentMethodId: this.state.customerData?.customer_id,
          customerId: this.state.customerData?._id,
        };
      }

      if (paymentGateway === commonStrings.multipass) {
        paymentDetails.paymentMethod = {
          gatewayPaymentMethodId: this.state.customerData?.cardWalletID,
          customerId: this.state.customerData?._id,
        };
      }
    }

    // One Time Card
    if (this.state.activeTab === 0 && !this.state.isStoredCard) {
      let encrypted_csc = '';
      let encrypted_number = '';
      let cardExpiryDate = '';

      if (paymentGateway === commonStrings.paytrace) {
        window.paytrace.submitEncrypted('#DemoForm');

        encrypted_csc = localStorage.getItem('1');
        encrypted_number = localStorage.getItem('0');
        cardExpiryDate = this.state.card.cardExpiryDate;

        localStorage.removeItem('0');
        localStorage.removeItem('1');
      }

      if (paymentGateway === commonStrings.multipass) {
        const tsepResponse = this.state.tsepSuccessResponse;
        encrypted_number = tsepResponse ? tsepResponse?.tsepToken : null;
        encrypted_csc = tsepResponse ? tsepResponse?.cvv2 : null;
        cardExpiryDate = tsepResponse?.expirationDate;
      }

      paymentDetails.paymentType = this.state.creditOrDebit?.toLowerCase() ?? commonStrings.debit;
      paymentDetails.paymentMethod = {
        accountName: this.state.payerName || `${this.state.customerData.firstName} ${this.state.customerData.lastName}`,
        encrypted_csc,
        encrypted_number,
        cardExpiryDate,
        cardType: this.state.cardType,
        creditOrDebit: this.state.creditOrDebit,
        binCodesResponse: this.state.binCodesResponse,
      };
    }

    // PaymentVault ACH
    if (this.state.activeTab === 1 && this.state.selectedPaymentMethod.paymentMethodId) {
      paymentDetails.paymentType = commonStrings.ach;
      paymentDetails.paymentMethod = {
        paymentMethodId: this.state.selectedPaymentMethod.paymentMethodId,
        customerId: this.state.customerData?._id,
      };
    }

    // One Time ACH
    if (this.state.activeTab === 1 && !this.state.selectedPaymentMethod.paymentMethodId) {
      paymentDetails.paymentType = commonStrings.ach;
      paymentDetails.paymentMethod = {
        accountNumber: this.state.ach.accountNumber,
        routingNumber: this.state.ach.routingNumber,
        accountName: this.state.ach.accountName,
      };
    }

    const invoiceData = this.state.invoiceData || {};

    /** @type {import('../../../types/invoices').UpdateInvoicePayload} */
    const payload = {
      invoiceId: invoiceData?._id,
      baseAmount: formatCurrencyInput(this.state.baseAmount),
      customerId: this.state.customerData?._id,
      paymentDetails,
    };

    if (checkAddressEnabled(this.state.addressSettings?.billingAddress)) {
      payload.billingAddress = {
        addressOne: this.state?.billingAddress?.addressOne || invoiceData?.billingAddress?.addressOne || '',
        addressTwo: this.state?.billingAddress?.addressTwo || invoiceData?.billingAddress?.addressTwo || '',
        city: this.state?.billingAddress?.city || invoiceData?.billingAddress?.city || '',
        state: this.state?.billingAddress?.state || invoiceData?.billingAddress?.state || '',
        zip: this.state?.billingAddress?.zip || invoiceData?.billingAddress?.zip || '',
      };
    }

    if (checkAddressEnabled(this.state.addressSettings?.shippingAddress)) {
      payload.shippingAddress = {
        addressOne: this.state?.shippingAddress?.addressOne || invoiceData?.shippingAddress?.addressOne || '',
        addressTwo: this.state?.shippingAddress?.addressTwo || invoiceData?.shippingAddress?.addressTwo || '',
        city: this.state?.shippingAddress?.city || invoiceData?.shippingAddress?.city || '',
        state: this.state?.shippingAddress?.state || invoiceData?.shippingAddress?.state || '',
        zip: this.state?.shippingAddress?.zip || invoiceData?.shippingAddress?.zip || '',
      };
    }

    /** @type {import('../../../../../types/invoices').UpdateInvoiceOptions} */
    const options = {
      payInvoice: true,
      /** Paylink notifications */
      sendEmail: false,
      sendText: false,
    };
    // Pay invoice request
    invoicesService
      .updateInvoice(invoiceId, payload, options)
      .then((_r) => {
        window.scrollTo(0, 0);
        this.props.history.push('/Customer/Payment/History');
      })
      .catch((e) => {
        const erMsg = e?.response?.data?.message ?? message.ERROR_CONTACT_SUPPORT;
        misMatchError.push(erMsg);
        this.setState({ misMatchError });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  handleCard(_e) {
    this.setState({ isStoredCard: false, paymentType: commonStrings.debit });
  }

  collectAllMisMatchError(result, misMatchError) {
    if (result.payload.error.data.response.length > 0) {
      let responseErrors = JSON.parse(result.payload.error.data.response);
      if (responseErrors.response_code === 1) {
        for (let key in responseErrors.errors) {
          let i = 0;
          misMatchError.push(responseErrors.errors[key][i] + '\n');
        }
      }
      if (responseErrors.response_code === 1001) {
        misMatchError.push(responseErrors.status_message);
      }
    }
  }

  validateAchCredentials(error) {
    let errorFlag = false;
    Object.keys(this.state.ach).forEach((key) => {
      if (
        validator(key, this.state.ach[key]) ||
        this.state.ach[key] === '' ||
        (typeof this.state.ach[key] === 'string' && this.state.ach[key].trim() === '')
      ) {
        error[key + 'Error'] = true;
        errorFlag = true;
      } else {
        error[key + 'Error'] = false;
      }
    });
    return errorFlag;
  }

  checkCardValues(state) {
    if (this.state.tabValue === 0) {
      this.setState({ ach: { ...this.state.ach, isOpen: false } });
      if (state.card.cardNumber.indexOf('_') > -1 || state.card.cardNumber === '') {
        this.setState({ errorCard: { ...this.state.errorCard, cardNumber: true } });
        return false;
      } else if (state.card.cardExpiryDate.indexOf('_') > -1 || state.card.cardExpiryDate === '') {
        this.setState({ errorCard: { ...this.state.errorCard, cardExpiryDate: true } });
        return false;
      } else if (state.card.cardCsc.indexOf('_') > -1 || state.card.cardCsc === '') {
        this.setState({ errorCard: { ...this.state.errorCard, cardCsc: true } });
        return false;
      } else {
        return true;
      }
    } else {
      this.setState({ ach: { ...this.state.ach, isOpen: true }, payerName: this.state.ach.accountName }, () => {
        delete this.state.zip;
      });
      return true; // already validated
    }
  }

  handleSubmitAddNewCard(_e, _t) {
    const cardDataInital = {
      cardCsc: '___',
      cardNumber: '',
      cardExpiryDate: '__/____',
    };
    this.setState({ card: { ...cardDataInital }, mask_number: '', name: '', updateCard: true, addNewCard: true });
  }

  openAdjustSettings() {
    this.setState({ isOpen: true });
  }

  handleClose = () => {
    this.setState({ isOpen: false, isLoading: true });
    this.fetchSettingData();
  };

  a11yProps(index) {
    return {
      id: `action-tab-${index}`,
      'aria-controls': `action-tabpanel-${index}`,
    };
  }

  handleChangeTab(e, val) {
    this.setState({ tabValue: val }, () => {
      if (val === 0) {
        this.setState({
          activeTab: 0,
          ach: { ...this.state.ach, isOpen: false },
          paymentType: this.state.creditOrDebit?.toLowerCase() ?? commonStrings.debit,
        });
      } else {
        this.setState({
          activeTab: 1,
          ach: { ...this.state.ach, isOpen: true },
          paymentType: commonStrings.ach,
        });
      }
    });
  }

  handlePdfDownload(_e) {
    let invoice = this.state.invoice;
    const path = config.BASEURL + 'downloadInvoiceFile/' + invoice;
    this.setState({ isLoading: true });
    setTimeout(() => {
      this.setState({ isLoading: false });
      window.open(path);
    }, 3500);
  }

  handlePolicyPDF(policyName) {
    const params = {
      companyId: this.state.companyId._id,
      locationId: this.state.locationId?._id,
      policyType: policyName,
    };
    this.setState({ isLoading: true });
    this.props.getPolicyPDF(params).then((response) => {
      if (response) {
        const { status, policyName } = response.payload.data;
        if (status === 200) {
          const fileURL = config.BASEURL + `getPolicies/${policyName}`;
          setTimeout(() => {
            this.setState({ isLoading: false });
            window.open(fileURL);
          }, 3500);
        }
      }
    });
  }

  removeCloseableMessage = (index) => {
    let misMatchError = this.state.misMatchError;
    delete misMatchError[index];
    this.setState({ misMatchError });
  };

  handleAddressChange = (event, type, isBillingAddressSameAsShippingAddress = false) => {
    let { id, value } = event.target;
    if (type === 'shippingAddress' || isBillingAddressSameAsShippingAddress) {
      const shippingAddress = {
        ...this.state.shippingAddress,
        [id]: value,
      };
      this.setState({ shippingAddress });
    }
    if (type === 'billingAddress') {
      const billingAddress = {
        ...this.state.billingAddress,
        [id]: value,
      };
      this.setState({ billingAddress });
    }
  };

  handleIsBillingAddressSameAsShippingAddress = (isBillingAddressSameAsShippingAddress = false) => {
    if (isBillingAddressSameAsShippingAddress) {
      this.setState({ shippingAddress: { ...this.state.billingAddress } });
    }
  };

  getPaymentTitle = () => {
    if (this.state.calculationResult?.options?.dualPricing === true) {
      if (this.state.activeTab === 0) return 'Card Price';
      else return 'Cash Price';
    } else {
      return 'Payment Amount';
    }
  };

  getBannerText = () => {
    return <p className={classes.bannerText}>{this.state.paymentPageBanner}</p>;
  };

  getCardTitle = () => {
    if (this.state.calculationResult?.options?.dualPricing) {
      return 'Card';
    } else if (!this.state.creditOrDebit) {
      return 'Card';
    } else {
      return `${this.state.creditOrDebit + ' Card'}`;
    }
  };

  capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  handleSelectAccountACH(selectedAccountDetails) {
    if (selectedAccountDetails) {
      let accountDetails = {
        ...selectedAccountDetails,
        accountNumber: selectedAccountDetails.maskedValue,
      };
      this.setState({
        ach: { ...this.state.ach, ...accountDetails },
        selectedPaymentMethod: { ...accountDetails },
      });
    } else {
      // if removing selected account
      this.setState({
        ach: { isSaveChecked: false, accountName: '', accountNumber: '', routingNumber: '', isOpen: true },
        selectedPaymentMethod: {},
      });
    }
  }

  handleCheckSaveACHAccount(isChecked) {
    // only change check if payment method not selected
    if (!this.state.selectedPaymentMethod.paymentMethodId?.length > 0) {
      this.setState({ ach: { ...this.state.ach, isSaveChecked: isChecked } });
    }
  }

  canAddAccount() {
    let canAddAccount = true;
    if (this.state.locationId.gateway === commonStrings.paytrace) {
      canAddAccount =
        this.state.savedPaymentMethods?.filter((method) => method.paymentType?.toLowerCase() === commonStrings.ach)
          .length === 0;
    }
    return canAddAccount;
  }

  TsepCardError = () => {
    return (
      <div>
        <Alert variant="outlined" severity="error">
          Payment form could not be loaded. There seems to a problem with gateway configuration. Please contact
          developer support.
        </Alert>
      </div>
    );
  };

  TsepForm = (isSavedCard) => {
    if (this.state.tsepAuth) {
      return (
        <div className={isSavedCard ? 'none' : 'block'}>
          <form method="POST" id="payment-form">
            <div id="tsep-cardContainer">
              <div id="tsep-cardNumDiv" data-auto-formatting="Y" data-validate-cc="Y" data-detect-card-type="Y"></div>
            </div>
            <div id="tsep-CardData">
              <div id="tsep-datepickerDiv" data-validate-expiry-date="Y"></div>
              <div id="tsep-cvv2Div" data-validate-cvv2="Y"></div>
            </div>
            <div id="tsep-cardHolderNameDiv" data-validate-name="Y" style={{ display: 'none' }}></div>
            <div id="tsep-zipCodeDiv" data-validate-zipcode="Y" style={{ display: 'none' }}></div>
          </form>
        </div>
      );
    } else {
      return this.TsepCardError();
    }
  };

  render() {
    const { t } = this.props;
    const isDeleted = this.state.STATUS === 'Deleted' ? true : false;
    const paymentGateway = this.state.locationId?.gateway || 'paytrace';
    if (paymentGateway === 'multipass') {
      autoFillMultipassFields();
    }
    return (
      <div className="rightPanel">
        <Topheader />
        <div className="contentPart">
          <Container component="main" maxWidth="xl">
            <Stack sx={{ width: '100%' }} spacing={2}>
              {this.state.misMatchError.map((e, id) => (
                <CloseableAlerts
                  key={id}
                  index={id}
                  message={e}
                  severity="error"
                  closer={this.removeCloseableMessage}
                />
              ))}
            </Stack>
            {this.state.successMessages ? (
              <SuccessMessage successes={[this.props.info.invoiceInfo.data.message]} />
            ) : (
              ''
            )}
            <FlexAlerts messages={this.state.messages} />
            {this.state.tsepFieldError ? <ErrorMessage errors={[this.state.tsepFieldError]} /> : ''}
            <div className="min-wrap pay-page desktopPage">
              <LoadingOverlay
                className={classes.tpTableFullW}
                active={this.state.isLoading}
                spinner
                text="Fetching your response ..."
              >
                {isDeleted ? (
                  <IsDeletedComponents invoiceId={this.state.invoice} />
                ) : this.state.successMessages ? (
                  <PaymentConfirmation
                    invoice={this.state.jobId ? this.state.jobId : this.state.invoice}
                    locationSettings={{
                      ...this.state.virtualTerminalSettings,
                      DualFeeEnabled: this.state.calculationResult?.options?.dualPricing,
                    }}
                    customerData={this.state?.customerId}
                    amount={this.state?.baseAmount}
                    total={this.state?.calculationResult?.totalAmount}
                    fees={{
                      svcFee: this.state.calculationResult?.fees?.cardUpcharge?.amount,
                      surcharge: this.state.calculationResult?.fees?.surcharge?.amount,
                      tax: this.state.calculationResult?.fees?.tax?.amount,
                    }}
                    selectedOption={this.state.activeTab === 0 ? 'card' : 'bank transfer'}
                    card={
                      this.state.isStoredCard
                        ? {
                            masked_card_number: this.state?.customerData?.masked_card_number,
                            cardType: this.state?.customerData?.cardType,
                          }
                        : this.state?.card
                    }
                    paymentType={this.state?.paymentType}
                    location={{
                      locationName: this.state.locationId?.locationName,
                      customInvoiceName: this.state.isCustomFieldEnabled ? this.state.invoiceLable : '',
                      image: this.state.locationId.image,
                    }}
                    ach={this.state?.ach}
                    paymentResponse={this.state?.paymentResponse}
                  />
                ) : (
                  <>
                    {this.state.isPaid || this.state.invalidMsg ? (
                      <h3 className="errorMsg mb-3">
                        Payment was already made for the invoice <a href={config.APPURL}>Back</a>
                      </h3>
                    ) : (
                      <Grid container spacing={3}>
                        <Grid item md={8}>
                          <input type="hidden" name="_csrf" value={this.state.csrf['csrf-token']} />
                          <input type="hidden" name="_csrfSecret" value={this.state.csrf['csrf-secret']} />
                          <div style={{ marginLeft: '18px', marginTop: '-30px', marginBottom: '10px' }}>
                            <h3 className="terminal-title">Invoice Payment</h3>
                          </div>
                          <Card>
                            <CardContent>
                              <div className="terminal-inner">
                                {this.state.isPaid ? (
                                  <h3 className="errorMsg">Payment link already has been used !</h3>
                                ) : (
                                  ''
                                )}
                                {this.state.invalidMsg ? (
                                  <h3 className="errorMsg mb-3">{this.state.invalidMsg}</h3>
                                ) : (
                                  ''
                                )}
                                <Grid container className="terminal-title-grid" spacing={3} alignItems="center">
                                  {this.state?.isPPB && (
                                    <Grid item sm={12}>
                                      <div className="borderd">{this.getBannerText()}</div>
                                    </Grid>
                                  )}
                                </Grid>
                                <form className={classes.form} id="DemoForm">
                                  <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12} md={12}>
                                      <Grid container>
                                        <Grid item md={12} className="mb-3">
                                          <label>{this.getPaymentTitle()}</label>
                                          <div className="pay-amount">
                                            {' '}
                                            {formatCurrency(
                                              this.state.calculationResult?.totalAmount || this.state.baseAmount
                                            )}
                                          </div>
                                        </Grid>
                                        <AppBar position="static" color="default">
                                          <Tabs
                                            value={this.state.tabValue}
                                            onChange={(e, val) => {
                                              this.handleChangeTab(e, val);
                                            }}
                                            indicatorColor="primary"
                                            textColor="primary"
                                            variant="fullWidth"
                                            aria-label="action tabs example"
                                          >
                                            <Tab label={this.getCardTitle()} {...this.a11yProps(0)} />
                                            {this.state.locationId?.ACH &&
                                            this.state.companyId &&
                                            this.state.companyId.ACH &&
                                            typeof this.state.createdBy !== 'undefined' &&
                                            this.state.createdBy.permissions.ach ? (
                                              <Tab label="Bank transfer" {...this.a11yProps(1)} />
                                            ) : (
                                              ''
                                            )}
                                          </Tabs>
                                        </AppBar>
                                        <TabedPanel value={this.state.tabValue} index={0}>
                                          <Grid container spacing={3}>
                                            <Grid item md={12}>
                                              <Textfield
                                                error={this.state.error.payerNameError}
                                                helperText={
                                                  this.state.error.payerNameError
                                                    ? rules.payerName.messages.characterlimit
                                                    : ''
                                                }
                                                id="payerName"
                                                type="text"
                                                variant="outlined"
                                                labels={t('Name')}
                                                value={this.state.payerName}
                                                width={true}
                                                onChange={(e) => this.handleChange(e, t)}
                                              />
                                            </Grid>
                                            <Grid item md={12}>
                                              {this.state.isStoredCard && (
                                                <Grid container spacing={3}>
                                                  <Grid item md={8}>
                                                    <div className="block">
                                                      <Card className={classNames(['maskData', 'customCardWraper'])}>
                                                        <div className="Card_header">
                                                          <Typography
                                                            variant="h5"
                                                            component="h2"
                                                            style={{ textTransform: 'capitalize' }}
                                                          >
                                                            Name :{' '}
                                                            {`${this.state.customerData.firstName} ${this.state.customerData.lastName}`}
                                                          </Typography>
                                                        </div>
                                                        <CardContent className="cardContents">
                                                          <label className="MuiTypography-gutterBottom">
                                                            {t('maskCardNumber')}
                                                          </label>
                                                          <Grid container item xs={12}>
                                                            {this.state.customerData.masked_card_number}
                                                          </Grid>
                                                        </CardContent>
                                                        <CardActions>
                                                          <Buttons
                                                            id="AddNewCard"
                                                            type="button"
                                                            variant="contained"
                                                            color="secondary"
                                                            className={'addNewCardBtn'}
                                                            onClick={(e) => this.handleCard(e)}
                                                            text={'Add Another Card'}
                                                          />
                                                        </CardActions>
                                                      </Card>
                                                    </div>
                                                  </Grid>
                                                </Grid>
                                              )}
                                              {paymentGateway === 'multipass' && this.TsepForm(this.state.isStoredCard)}
                                              {paymentGateway === 'paytrace' && !this.state.isStoredCard && (
                                                <>
                                                  <Grid item md={12}>
                                                    {this.state.errorCard.cardNumber ? (
                                                      <label
                                                        className={classNames([
                                                          'MuiTypography-gutterBottom',
                                                          this.state.errorCard.cardNumber ? 'errorCard' : '',
                                                        ])}
                                                      >
                                                        Please enter credit card details
                                                      </label>
                                                    ) : (
                                                      <label
                                                        className={classNames([
                                                          'MuiTypography-gutterBottom',
                                                          this.state.errorCard.cardNumber ? 'errorCard' : '',
                                                        ])}
                                                      >
                                                        Card Number
                                                      </label>
                                                    )}
                                                    <MaskedInput
                                                      type="text"
                                                      value={this.state.card.cardNumber}
                                                      className={classNames([classes.cardNum, 'pt-encrypt'])}
                                                      mask={
                                                        this.state.americanExpress
                                                          ? '111111111111111'
                                                          : '1111111111111111'
                                                      }
                                                      labels={t('cardNumber')}
                                                      id="cardNumber"
                                                      name="encrypted_number"
                                                      size="20"
                                                      onChange={(e) => this.handleChangeCard(e, t)}
                                                    />
                                                  </Grid>
                                                  <Grid className={classes.exp_Cvv}>
                                                    <Grid item md={4}>
                                                      {this.state.errorCard.cardExpiryDate ? (
                                                        <label
                                                          className={classNames([
                                                            'MuiTypography-gutterBottom',
                                                            this.state.errorCard.cardExpiryDate ? 'errorCard' : '',
                                                          ])}
                                                        >
                                                          Invalid Expiry Date
                                                        </label>
                                                      ) : (
                                                        <label
                                                          className={classNames([
                                                            'MuiTypography-gutterBottom',
                                                            this.state.errorCard.cardExpiryDate ? 'errorCard' : '',
                                                          ])}
                                                        >
                                                          Exp Date
                                                        </label>
                                                      )}
                                                      <MaskedInput
                                                        mask="11/1111"
                                                        className={classes.expDate}
                                                        value={this.state.card.cardExpiryDate}
                                                        name="cardExpiryDate"
                                                        id="cardExpiryDate"
                                                        placeholder="mm/yyyy"
                                                        ref={this.expiryDateRef}
                                                        onChange={(e) => this.handleChangeCard(e, t)}
                                                      />
                                                    </Grid>
                                                    <Grid item md={2}>
                                                      {this.state.errorCard.cardCsc ? (
                                                        <label
                                                          className={classNames([
                                                            'MuiTypography-gutterBottom',
                                                            this.state.errorCard.cardCsc ? 'errorCard' : '',
                                                          ])}
                                                        >
                                                          CVV Invalid
                                                        </label>
                                                      ) : (
                                                        <label
                                                          className={classNames([
                                                            'MuiTypography-gutterBottom',
                                                            this.state.errorCard.cardCsc ? 'errorCard' : '',
                                                          ])}
                                                        >
                                                          CVV
                                                        </label>
                                                      )}
                                                      <MaskedInput
                                                        type="text"
                                                        className={classNames([classes.cardCvv, 'pt-encrypt'])}
                                                        value={this.state.card.cardCsc}
                                                        mask={this.state.americanExpress ? '1111' : '111'}
                                                        id="cardCsc"
                                                        name="encrypted_csc"
                                                        ref={this.cscCardRef}
                                                        onChange={(e) => this.handleChangeCard(e, t)}
                                                      />
                                                    </Grid>
                                                  </Grid>
                                                </>
                                              )}
                                            </Grid>
                                            {this.state.isZip ? (
                                              <Grid item md={6}>
                                                <label>{t('Zip')}</label>
                                                <Textfield
                                                  error={this.state.error.zipError}
                                                  id="zip"
                                                  type="text"
                                                  variant="outlined"
                                                  // labels={t("Zip")}
                                                  value={this.state.zip}
                                                  width={true}
                                                  onChange={(e) => {
                                                    const numberRegex = /^[0-9\b]+$/;
                                                    if (e.target.value === '' || numberRegex.test(e.target.value)) {
                                                      this.handleChange(e, t);
                                                    }
                                                  }}
                                                />
                                              </Grid>
                                            ) : (
                                              ''
                                            )}
                                            {this.state.isAddress ? (
                                              <Grid item md={6}>
                                                <label>{t('Address')}</label>
                                                <Textfield
                                                  error={this.state.error.addressError}
                                                  id="address"
                                                  type="text"
                                                  variant="outlined"
                                                  // labels={t("Zip")}
                                                  value={this.state.address}
                                                  width={true}
                                                  onChange={(e) => this.handleChange(e, t)}
                                                />
                                              </Grid>
                                            ) : (
                                              ''
                                            )}
                                            {checkAddressEnabled(this.state.addressSettings?.billingAddress) && (
                                              <Grid item xs={12} sm={12} md={12}>
                                                <AddressFieldsDropDown
                                                  type="billing"
                                                  state={this.state}
                                                  handleChange={this.handleAddressChange}
                                                  handleSameAddress={this.handleIsBillingAddressSameAsShippingAddress}
                                                />
                                              </Grid>
                                            )}
                                            {checkAddressEnabled(this.state.addressSettings?.shippingAddress) && (
                                              <Grid item xs={12} sm={12} md={12}>
                                                <AddressFieldsDropDown
                                                  type="shipping"
                                                  state={this.state}
                                                  handleChange={this.handleAddressChange}
                                                  handleSameAddress={this.handleIsBillingAddressSameAsShippingAddress}
                                                />
                                              </Grid>
                                            )}
                                          </Grid>
                                        </TabedPanel>
                                        <TabedPanel value={this.state.tabValue} index={1}>
                                          <Grid container spacing={2}>
                                            {this.state.locationId?.ACHPaymentVault && (
                                              <Grid item xs={12} md={12}>
                                                <SelectAccount
                                                  paymentMethods={this.state.savedPaymentMethods}
                                                  selectAccount={(option) => {
                                                    this.handleSelectAccountACH(option);
                                                  }}
                                                  selectedAccount={this.state.selectedPaymentMethod}
                                                  type={commonStrings.ach}
                                                />
                                              </Grid>
                                            )}
                                            <Grid item xs={12} md={12}>
                                              <ACHForm
                                                ach={this.state.ach}
                                                handleChangeACH={(e) => this.handleChangeACH(e)}
                                                variant="basicListTight"
                                                location={this.state.locationId}
                                                ref={this.achFormValidationRef}
                                              />
                                            </Grid>
                                            {this.state.locationId?.ACHPaymentVault &&
                                              this.state.customerData?._id?.length > 0 &&
                                              this.canAddAccount() && (
                                                <Grid item xs={12} md={12}>
                                                  <FormControlLabel
                                                    label="Save bank account for future use"
                                                    control={
                                                      <Checkbox
                                                        checked={
                                                          this.state.selectedPaymentMethod.paymentMethodId?.length >
                                                            0 || this.state.ach.isSaveChecked
                                                        }
                                                        onChange={(_e, value) => this.handleCheckSaveACHAccount(value)}
                                                        color="primary"
                                                      />
                                                    }
                                                  />
                                                </Grid>
                                              )}
                                            {this.state.isZip ? (
                                              <Grid item md={6}>
                                                <label>{t('Zip')}</label>
                                                <Textfield
                                                  error={this.state.error.zipError}
                                                  id="zip"
                                                  type="text"
                                                  variant="outlined"
                                                  // labels={t("Zip")}
                                                  value={this.state.zip}
                                                  width={true}
                                                  onChange={(e) => {
                                                    const numberRegex = /^[0-9\b]+$/;
                                                    if (e.target.value === '' || numberRegex.test(e.target.value)) {
                                                      this.handleChange(e, t);
                                                    }
                                                  }}
                                                />
                                              </Grid>
                                            ) : (
                                              ''
                                            )}
                                            {this.state.isAddress ? (
                                              <Grid item md={6}>
                                                <label>{t('Address')}</label>
                                                <Textfield
                                                  error={this.state.error.addressError}
                                                  id="address"
                                                  type="text"
                                                  variant="outlined"
                                                  // labels={t("Zip")}
                                                  value={this.state.address}
                                                  width={true}
                                                  onChange={(e) => this.handleChange(e, t)}
                                                />
                                              </Grid>
                                            ) : (
                                              ''
                                            )}
                                            {checkAddressEnabled(this.state.addressSettings?.billingAddress) && (
                                              <Grid item xs={12} sm={12} md={12}>
                                                <AddressFieldsDropDown
                                                  type="billing"
                                                  state={this.state}
                                                  handleChange={this.handleAddressChange}
                                                  handleSameAddress={this.handleIsBillingAddressSameAsShippingAddress}
                                                />
                                              </Grid>
                                            )}
                                            {checkAddressEnabled(this.state.addressSettings?.shippingAddress) && (
                                              <Grid item xs={12} sm={12} md={12}>
                                                <AddressFieldsDropDown
                                                  type="shipping"
                                                  state={this.state}
                                                  handleChange={this.handleAddressChange}
                                                  handleSameAddress={this.handleIsBillingAddressSameAsShippingAddress}
                                                />
                                              </Grid>
                                            )}
                                          </Grid>
                                        </TabedPanel>
                                      </Grid>
                                      <Grid item md={12}>
                                        {this.state.isPaid ||
                                        this.state.invoice === '' ||
                                        this.state.successMessages ? (
                                          ''
                                        ) : (
                                          <Buttons
                                            startIcon={<LockOutlinedIcon />}
                                            id="signUp"
                                            type="button"
                                            fullWidth={true}
                                            variant="contained"
                                            color="primary"
                                            className={classes.payBtn}
                                            disabled={
                                              this.state.tabValue === 0 &&
                                              paymentGateway === 'multipass' &&
                                              !this.state.tsepFieldSuccess &&
                                              !this.state.isStoredCard
                                            }
                                            onClick={(e) => this.handleSubmit(e, t)}
                                            text={t('Pay')}
                                          />
                                        )}
                                      </Grid>
                                      <Grid item md={12}>
                                        {this.state.activeTab === 0 ? (
                                          <p className="font-sm">
                                            By clicking 'Pay' I authorize {this.state.locationId?.locationName} to
                                            charge my card {formatCurrency(this.state.calculationResult?.totalAmount)}{' '}
                                            on {new Date(this.state.dueDate).toDateString()}.
                                            <Link
                                              className={[classes.back, classes.curser]}
                                              onClick={() => this.handlePolicyPDF('privacy_policy')}
                                            >
                                              {' '}
                                              Privacy Statement.
                                            </Link>
                                            <Link
                                              className={[classes.back, classes.curser]}
                                              onClick={() => this.handlePolicyPDF('refund_policy')}
                                            >
                                              {' '}
                                              Refund Policy.
                                            </Link>
                                          </p>
                                        ) : (
                                          <p className="font-sm">
                                            By clicking 'Pay' I authorize {this.state.locationId?.locationName} to debit
                                            my bank account by ACH{' '}
                                            {formatCurrency(this.state.calculationResult?.totalAmount)} on{' '}
                                            {new Date().toDateString()}.{' '}
                                            <Link
                                              className={[classes.back, classes.curser]}
                                              onClick={() => this.handlePolicyPDF('privacy_policy')}
                                            >
                                              {' '}
                                              Privacy Statement.
                                            </Link>
                                            <Link
                                              className={[classes.back, classes.curser]}
                                              onClick={() => this.handlePolicyPDF('refund_policy')}
                                            >
                                              {' '}
                                              Refund Policy.
                                            </Link>
                                          </p>
                                        )}
                                      </Grid>
                                      <Grid item md={12}>
                                        <div
                                          className="font-sm"
                                          dangerouslySetInnerHTML={{ __html: this.state.billingTerms }}
                                        ></div>
                                        {this?.state?.isPaymentTermConditionEnabled && (
                                          <div
                                            className="font-sm"
                                            dangerouslySetInnerHTML={{ __html: this.state.paymentTermCondition }}
                                          ></div>
                                        )}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </form>
                              </div>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item md={4}>
                          <Card>
                            <CardContent>
                              <Grid container spacing={3}>
                                <Grid item xs={12}>
                                  <Buttons
                                    id="vInvoice"
                                    type="button"
                                    fullWidth={true}
                                    className={classes.viewInvoice}
                                    variant="outlined"
                                    onClick={(e) => this.handlePdfDownload(e, t)}
                                    text={t('ViewInvoice')}
                                  />
                                </Grid>
                                <Grid item xs={12} className={classes.invoiceDetail}>
                                  <Table className={classes.table} size="small" aria-label="a dense table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="left">{this.state.invoiceLable}</TableCell>
                                        <TableCell align="right" style={{ overflowWrap: 'anywhere' }}>
                                          {this.state.jobId ? this.state.jobId : this.state.invoice}
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell align="left">Due date</TableCell>
                                        <TableCell align="right">
                                          {new Date(this.state.dueDate).toDateString()}
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </Grid>
                                <Grid item xs={12}>
                                  <FeeDisplay
                                    baseAmount={this.state.baseAmount}
                                    paymentType={this.state.paymentType}
                                    state={this.state.billingAddress?.state}
                                    setCalculationResult={(newCalculationResult) => {
                                      this.setState({ calculationResult: newCalculationResult });
                                    }}
                                    setError={(err) => {
                                      this.setState((prevState) => ({
                                        messages: [
                                          ...prevState.messages,
                                          { severity: AlertSeverityTypes.error, message: err?.message },
                                        ],
                                      }));
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    )}
                  </>
                )}
              </LoadingOverlay>
            </div>
          </Container>
        </div>
      </div>
    );
  }
}
Payment.propTypes = {
  value: PropTypes.any,
  index: PropTypes.any,
  getCsrfToken: PropTypes.any,
  match: PropTypes.any,
  InvoiceDetailByIdForPay: PropTypes.any,
  PAYTRACE_AWS_PATH: PropTypes.any,
  t: PropTypes.any,
  UserDetail: PropTypes.any,
  children: PropTypes.any,
  invoiceId: PropTypes.any,
  UserDetailById: PropTypes.any,
  DownloadInvoice: PropTypes.any,
  info: PropTypes.any,
  termsAndConditions: PropTypes.any,
  getPolicyPDF: PropTypes.any,
  getLocationTermsAndConditions: PropTypes.any,
  history: PropTypes.any,
  CustomerDetailsId: PropTypes.func,
};
function mapStateToProps(state) {
  return {
    info: state.InvoiceReducer,
    UserDetail: state.AdminUserReducer,
    PAYTRACE_AWS_PATH: state.EnvironmentVariablesReducer.data.PAYTRACE_AWS_PATH,
    termsAndConditions: state.TermsConditionReducer,
  };
}

export default connect(mapStateToProps, {
  getCsrfToken,
  DownloadInvoice,
  UserDetailById,
  InvoiceDetailByIdForPay,
  getPolicyPDF,
  getInvoiceNumber,
  countryDataList,
  getLocationTermsAndConditions,
  CustomerDetailsId,
})(withTranslation()(Payment));
